// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodPaymentsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/period_payments endpoint
 *
 * Returns payments list for a payroll period with counts.
 */
import type { Payroll_PeriodRow } from './Payroll_PeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_PeriodPaymentsResponseDados {
period: Payroll_PeriodRow
payments: unknown[]
paid_count: number
pending_count: number
total_count: number
}

export type Payroll_PeriodPaymentsResponse = ApiResponse<Payroll_PeriodPaymentsResponseDados>;

registerResponseContract('Payroll_PeriodPaymentsResponse', {
  period: {
    type: 'object',
    required: true,
    fields: {
      id:                           { type: 'number',  required: true },
      franchise_id:                 { type: 'number',  required: true },
      user_id:                      { type: 'string',  required: true },
      period_start_date:            { type: 'string',  required: true },
      period_end_date:              { type: 'string',  required: true },
      revenue_conciliation_amount:  { type: 'string',  required: true },
      expenses_conciliation_amount: { type: 'string',  required: true },
      status:                       { type: 'number',  required: true },
      total_amount:                 { type: 'string',  required: true },
      created_at:                   { type: 'string',  required: true },
      updated_at:                   { type: 'string',  required: true },
      calculated_at:                { type: 'string',  required: false },
      paid_at:                      { type: 'string',  required: false },
      paid_by:                      { type: 'string',  required: false },
      franchise_name:               { type: 'string',  required: false },
    },
  },
  payments:      { type: 'array',   required: true },
  paid_count:    { type: 'number',  required: true },
  pending_count: { type: 'number',  required: true },
  total_count:   { type: 'number',  required: true },
})
